import React, { Component } from 'react';
import Header from './Header';
import Routing from './Routing';
import Contact from './shared/contact';
import Footer from './shared/footer';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollMemory from 'react-router-scroll-memory';

class App extends Component {

  render() {
    return (
      <div className="container">
        <Router onUpdate={window.scrollTo(0, 0)} >
          <div>
            <ScrollMemory />
            <Header />
            <Routing />
            <Contact />
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js